import React from "react";
import PropTypes from "prop-types";
import OutlinedLink from "components/views/atoms/OutlinedLink";
import MoreTechInfo from "components/views/atoms/OutlinedLinkContent/MoreTechInfo";
import GA from "components/utils/GA";

const navigateTechInfo = (_lbl) => {
  GA.event({
    category: "homepage",
    action: "tech_info_link",
    label: _lbl,
  });
  window.open(_lbl, '_blank');
}

const OutlinedMoreTechInfo = ({ LinkLabel, className }) => {
  const classes = ["OutlinedMoreTechInfo"];
  if (className) classes.push(className);

  return (
    <OutlinedLink className={classes.join(" ")} onClick={() => navigateTechInfo(LinkLabel)}>
      <MoreTechInfo />
    </OutlinedLink>
  );
};

OutlinedMoreTechInfo.displayName = "OutlinedMoreTechInfo";

OutlinedMoreTechInfo.propTypes = {
  className: PropTypes.string,  
  LinkLabel : PropTypes.string
};

OutlinedMoreTechInfo.defaultProps = {
  className: null,
  LinkLabel : ""
};

export default OutlinedMoreTechInfo;
